<template>
  <div id="editConsultationContainer" class="vs-con-loading__container">

    <vs-collapse type="margin" class="pt-0">
      <vs-collapse-item open v-if="consultationFormData">
        <div class="flex items-center" slot="header">
          <feather-icon icon="PhoneIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
          <strong class="text-white" v-text="$t('counseling_management')"></strong>
        </div>
        <div class="vx-row">

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('consultant_name')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="consultationFormData.consultant_name" class="w-full" disabled/>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('business_person')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="extensionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.assigned_agent_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.assigned_agent_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in extensionOptions" :key="'assigned_agent_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormDataErrors.assigned_agent_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('classification')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="divisionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.division_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.division_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in divisionOptions" :key="'division_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormDataErrors.division_id"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('treatment_result')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.result_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.result_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in resultOptions" :key="'result_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormDataErrors.result_type_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('big')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="bigOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.big_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.big_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in bigOptions" :key="'big_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormDataErrors.big_type_id"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('middle_class')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="smallOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.small_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.small_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in smallOptions" :key="'small_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormDataErrors.small_type_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div v-for="(customField, key) in customFields" v-bind:key="'consultationCustomField_' + key" class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="customField.title"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <template v-if="customField.type == 'Text'">
                  <vs-input v-model="consultationFormData.custom_fields_form_data[key].value" class="w-full"/>
                </template>

                <template v-if="customField.type == 'Select'">
<!--                  <v-select :options="customField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.custom_fields_form_data[key].value" class="md:mb-0" />-->
                  <select v-model="consultationFormData.custom_fields_form_data[key].value" class="vs-inputx vs-input--input normal md:mb-0">
                    <option value="">{{ $t('please_select') }}</option>
                    <option v-for="(option, key) in customField.options" :key="'consultation_custom_fields_' + key" :value="option.value">{{ option.label }}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-2/12 w-full">
            <strong v-text="$t('consulting_title')"></strong>
          </div>
          <div class="vx-col sm:w-10/12 w-full">
            <vs-input v-model="consultationFormData.title" class="w-full"/>
            <validation-error :model-error="consultationFormDataErrors.title"></validation-error>
          </div>
        </div>
        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-2/12 w-full">
            <strong v-text="$t('consultation_contents')"></strong>
          </div>
          <div class="vx-col sm:w-10/12 w-full">
            <vs-textarea class="mb-0" v-model="consultationFormData.content" />
            <validation-error :model-error="consultationFormDataErrors.content"></validation-error>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>

</template>

<script>
import Consultation from '@/models/Consultation'
import Big from '@/models/Big'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Shared.Consultations.Consultations.Edit',
  data () {
    return {
      memberId: 0,
      consultationId: 0,

      consultationFormData: {
        id: '',
        title: '',
        content: '',
        assigned_agent_id: '',
        division_id: '',
        result_type_id: '',
        big_type_id: '',
        small_type_id: '',
        consultant_name: '',
        custom_fields_for_data: []
      },
      consultationFormDataErrors: {},

      customFields: {},
      divisionOptions: [],
      resultOptions: [],
      extensionOptions: [],
      bigOptions: [],
      smallOptions: []
    }
  },
  mounted () {
    EventBus.$on('initResetEditConsultationFormData', this.initResetEditConsultationFormData)
    EventBus.$on('initLoadEditConsultation', this.initLoadEditConsultation)
    EventBus.$on('initSaveConsultationFormData', this.initSaveConsultationFormData)
  },
  watch: {
    'consultationFormData.big_type_id' () {
      this.getSmallOptions()
    }
  },
  methods: {
    initResetEditConsultationFormData () {
      this.consultationFormData = {
        id: '',
        title: '',
        content: '',
        assigned_agent_id: '',
        division_id: '',
        result_type_id: '',
        big_type_id: '',
        small_type_id: '',
        consultant_name: '',
        custom_fields_for_data: []
      }
    },
    async initLoadEditConsultation (data) {
      this.$vs.loading({container: '#EditConsultationDataContainer'})

      this.memberId = data.id
      this.consultationId = data.consultationId

      try {

        const consultationResponse = await Consultation.viewConsultation({ id: this.memberId, consultationId: this.consultationId })

        this.consultationFormData = consultationResponse.data.data
        this.divisionOptions = consultationResponse.data.meta.options.divisions
        this.resultOptions = consultationResponse.data.meta.options.results
        this.extensionOptions = consultationResponse.data.meta.options.extensions
        this.bigOptions = consultationResponse.data.meta.options.bigs
        this.smallOptions = consultationResponse.data.meta.options.smalls
        this.customFields = consultationResponse.data.meta.custom_fields

      } catch (e) {
        this.$swalHelper.error({
          title: '',
          text: e.response.data.message,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#EditConsultationDataContainer > .con-vs-loading')

    },
    async initSaveConsultationFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editConsultationButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await Consultation.updateConsultation(this.consultationFormData)
          this.$emit('editConsultationSuccess', response)
          this.$store.dispatch('setIsFormInProgress', false)
        }
      } catch (e) {
        this.consultationFormDataErrors = e.response.data.errors
        this.$swalHelper.error({
          title: '',
          text: e.response.data.message,
          confirmButton: this.$t('confirm')
        })
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editConsultationButton > .con-vs-loading')

    },
    async getSmallOptions () {
      try {
        const response = await Big.getSmallOptions({ id: this.consultationFormData.big_type_id })
        this.smallOptions = response.data.smalls
      } catch (e) {
        this.$swalHelper.error({
          title: '',
          text: e.response.data.message,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}

</script>

<style lang="scss">
  #editConsultationButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
  #editConsultationContainer {
    padding-bottom: 50px;
    min-width: 900px;

    .vs-collapse-item--header {
      background-color: #667c8a;
      padding: 8px;
    }

    .actions {
      z-index: 999;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      justify-content: center;
      align-items: center;
      background-color: #eee;
    }
  }
</style>

